// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon_wrapper {
  text-align: center;
  padding-bottom: 30px;
}
.coupon_wrapper h3 {
  font-size: 28px;
  color: var(--ion-color-secondary);
  font-family: Tusker, Helvetica, sans-serif;
}
.coupon_wrapper p {
  font-size: 14px;
  color: var(--color-h);
  padding: 10px !important;
}
.coupon_wrapper ion-item {
  --min-height: 45px;
  border-radius: 7px;
  --background: transparent;
  --border: none;
  text-align: center;
  margin: 0 auto;
  width: 50%;
  --background: white;
  --inner-padding-end: 0px;
  --inner-padding-start: 0px;
  margin-bottom: 20px;
  --padding-start: 0px !important;
}
@media (max-width: 992px) {
  .coupon_wrapper ion-item {
    width: 100%;
  }
}
.coupon_wrapper .active {
  border: 1.5px solid var(--ion-color-secondary);
  color: var(--color-h);
}
.coupon_wrapper ion-input {
  border: 1.5px solid rgb(175, 175, 175);
  border-radius: 10px;
  --font-family: Tusker, sans-serif;
  font-size: 30px;
  color: rgb(175, 175, 175);
  --letter-spacing: 20px !important;
  background: white;
  height: 70px;
  overflow: hidden;
}
@media (max-width: 992px) {
  .coupon_wrapper ion-input {
    font-size: 20px;
  }
}
.coupon_wrapper ion-input input {
  letter-spacing: 20px !important;
}
.coupon_wrapper .error_message_code {
  padding: 5px 0px 20px;
  color: #E2000E;
}

ion-button {
  text-transform: initial;
}

.social_links {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-bottom: 30px;
}
.social_links ion-img {
  width: 100px;
}
.social_links .google {
  width: 130px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/coupons-section/coupons-section.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,oBAAA;AADJ;AAEI;EACI,eAAA;EACA,iCAAA;EACA,0CAAA;AAAR;AAEI;EACI,eAAA;EACA,qBAAA;EACA,wBAAA;AAAR;AAEI;EACI,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EAEA,mBAAA;EACA,wBAAA;EACA,0BAAA;EAIA,mBAAA;EACA,+BAAA;AAJR;ACpBE;EDQE;IAaQ,WAAA;EAGV;AACF;AACI;EACI,8CAAA;EACA,qBAAA;AACR;AACI;EACI,sCAAA;EACA,mBAAA;EACA,iCAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACR;ACxCE;ED8BE;IAWQ,eAAA;EAGV;AACF;AAFQ;EACI,+BAAA;AAIZ;AADI;EACI,qBAAA;EACA,cACA;AAER;;AACA;EACI,uBAAA;AAEJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;AAEI;EACI,YAAA;AAAR;AAEI;EACI,YAAA;AAAR","sourcesContent":["@import \"../../../theme/mixins\";\n\n.coupon_wrapper {\n    text-align: center;\n    padding-bottom: 30px;\n    h3 {\n        font-size: 28px;\n        color: var(--ion-color-secondary);\n        font-family: Tusker, Helvetica, sans-serif;\n    }\n    p {\n        font-size: 14px;\n        color: var(--color-h);\n        padding: 10px !important;\n    }\n    ion-item {\n        --min-height: 45px;\n        border-radius: 7px;\n        --background: transparent;\n        --border: none;\n        text-align: center;\n        margin:  0 auto;\n        width: 50%;\n      \n        --background: white;\n        --inner-padding-end: 0px;\n        --inner-padding-start: 0px;\n        @include mobile {\n            width: 100%;\n        }\n        margin-bottom: 20px;\n        --padding-start: 0px !important;\n    }\n    .active {\n        border: 1.5px solid  var(--ion-color-secondary);\n        color: var(--color-h);\n    }\n    ion-input {\n        border: 1.5px solid  rgb(175, 175, 175);\n        border-radius: 10px;\n        --font-family: Tusker, sans-serif;\n        font-size: 30px;\n        color: rgb(175, 175, 175);\n        --letter-spacing: 20px !important;\n        background: white;\n        height: 70px;\n        overflow: hidden;\n        @include mobile {\n            font-size: 20px;\n        }\n        input {\n            letter-spacing: 20px !important;\n        }\n    }\n    .error_message_code {\n        padding: 5px 0px 20px;\n        color: \n        #E2000E;\n    }\n}\nion-button {\n    text-transform: initial;\n    // &[disabled] {\n    //     opacity: 1;\n    //     --background: #CCCCCC;\n    // }\n}\n.social_links {\n    display: flex;\n    justify-content: center;\n    flex-wrap: nowrap;\n    margin-bottom: 30px;\n    ion-img {\n        width: 100px;\n    }\n    .google {\n        width: 130px;\n    }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
